module.exports = __webpack_public_path__ + "img/hospitalRed.feba4163.svg";